import React, { useState, useEffect } from 'react';
import styles from './Desktop.module.scss';
import './styles.css';
import strings from '../../../../../../globalization';
import { withRouter } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import PermitsHeader from '../../../../../../components/PermitsHeader';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import dimensions from '../../../../../../util/dimensions-util';
import TextInput from '../../../../../../components/TextInput';
import DateRangeSelectionModal from './DateRangeSelectionModal';
import Button from '../../../../../../components/Button';

import calendarBlue from '../../../../../../assets/images/calendar-blue-icon/image.png';
import downloadIcon from '../../../../../../assets/images/download-icon/download-icon.png';

import SannaLogo from '../../../../../../components/SannaLogo';
import {
  DATE_SELECTION_MODES,
  formatPeriodDisplayLabel,
} from '../../dateUtils';
import {
  AGENCY_REPORT_TABS,
  handleReportTabClick,
} from '../../../shared/reportTabs';

const { vw: widthConstant, vh: heightConstant } = dimensions;

const Desktop = props => {
  const {
    onClick,
    onChange,
    statuses,
    selectedStatus,
    selectedDropDownStatus,
    searchText,
    dates,
    startDate,
    endDate,
    perPage,
    permitList,
    startTime,
    endTime,
    totalCount,
    selectedType,
    dateSelectionMode,
    selectedYear,
    periodSelectionType,
  } = props;
  console.log('vehicle list', permitList);
  console.log('selected type:', selectedStatus);

  const defaultCellStyle = {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.5,
    whiteSpace: 'normal',
  };

  const formatDateTime = value =>
    value ? moment(value).format('DD/MM/YYYY HH:mm') : '-';

  const formatStatus = value =>
    value ? String(value).replace(/_/g, ' ') : '-';

  const columnDefs = [
    {
      headerName: 'Permit reference ID (Entry)',
      field: 'entryPermitRefId',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Permit reference ID (Exit)',
      field: 'exitPermitRefId',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Vehicle Registration Number',
      field: 'vehicleRegistrationNumber',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Vehicle Owner Name',
      field: 'ownerName',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Entry Agency',
      field: 'entryAgency',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Entry Gate',
      field: 'entryGateName',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Entry Time Stamp',
      field: 'entryDate',
      headerClass: styles.rowHeader,
      width: 210 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatDateTime(params.value),
    },
    {
      headerName: 'Exit Agency',
      field: 'exitAgency',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Exit Gate',
      field: 'exitGateName',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Exit Time Stamp',
      field: 'exitDate',
      headerClass: styles.rowHeader,
      width: 210 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatDateTime(params.value),
    },
    {
      headerName: 'Credits',
      field: 'numberOfPasses',
      headerClass: styles.rowHeader,
      width: 130 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params =>
        params.value !== null && params.value !== undefined
          ? params.value
          : '-',
    },
    {
      headerName: 'Reconciliation Status',
      field: 'reconciliationStatus',
      headerClass: styles.rowHeader,
      width: 240 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatStatus(params.value),
    },
  ];

  const [showDateModal, setShowDateModal] = useState(false);

  const [gridApi, setGridApi] = useState(null);
  const onGridReady = params => {
    setGridApi(params.api);
    onChange('gridAPI', params.api);
  };
  const updateTable = () => {
    onChange('updateTable', null);
  };

 

  useEffect(() => {
    console.log(gridApi);
    if (gridApi && totalCount > 10) {
      console.log('changing to normal');
      gridApi.setDomLayout('normal');
    } else if (gridApi) {
      console.log('changing to autoHeight');
      gridApi.setDomLayout('autoHeight');
    }
  }, [totalCount]);

  useEffect(() => {
    console.log(gridApi);
    updateTable();
  }, [gridApi, startDate, endDate, startTime, endTime, selectedStatus, dateSelectionMode]);

  const onTabClick = id => {
    handleReportTabClick(id, onClick);
  };

  const isTodayMode = dateSelectionMode === DATE_SELECTION_MODES.TODAY;

  const getSelectedRangeLabel = () =>
    formatPeriodDisplayLabel({
      dateSelectionMode,
      dates,
      startDate,
      endDate,
      startTime,
      endTime,
    }) || strings.ADMIN.dateRange;

  const handleApplyDateSelection = selection => {
    onChange('applyDateSelection', selection);
  };
  const rowStyle = { border: 'none', cursor: 'pointer' };
  const getRowStyle = params => {
    if (params.node.rowIndex % 2 === 0) {
      return { background: '#f6f6f6', border: 'none' };
    }
  };

  const handleClear = () => {
    setShowDateModal(false);
    onClick('clearFilters');
  };
  const handleInput = text => {
    onChange('search', text);
  };
  const handleButtonClick = () => {
    onClick('apply');
  };

  return (
    <div className={styles.agencyContainer}>
      <PermitsHeader
        title={'Vehicle Entry & Exit'}
        onTabClick={onTabClick}
        tabs={AGENCY_REPORT_TABS}
        activeTab={3}
      />
      <div className={styles.bodyContainer}>
        <div className={styles.header}>
          <div className={styles.left}>
            <button
              type="button"
              className={styles.selectedRangeChip}
              onClick={() => setShowDateModal(true)}
              aria-label="Change date range">
              <span className={styles.selectedRangeType}>
                {isTodayMode ? 'Today' : 'Period'}
              </span>
              <span className={styles.selectedRangeValue}>
                {getSelectedRangeLabel()}
              </span>
              <img
                src={calendarBlue}
                className={styles.selectedRangeIcon}
                alt=""
              />
            </button>
            <DateRangeSelectionModal
              isOpen={showDateModal}
              onClose={() => setShowDateModal(false)}
              onApply={handleApplyDateSelection}
              dateSelectionMode={dateSelectionMode}
              selectedYear={selectedYear}
              periodSelectionType={periodSelectionType}
              startDate={startDate}
              endDate={endDate}
              dates={dates}
              startTime={startTime}
              endTime={endTime}
            />
          </div>
          <div className={styles.right}>
            <div className={styles.inputSearch}>
              <TextInput
                onChange={handleInput}
                isEdit={true}
                type={'text'}
                value={searchText}
                inputStyle={styles.inputText}
                showSeacrh={true}
                placeholder="Search with vehicle reg. number"
              />
            </div>
            <div onClick={handleClear} className={styles.clearLabel}>
              {strings.ADMIN.clear}
            </div>
            <Button
              onClick={handleButtonClick}
              label={strings.ADMIN.apply}
              className={styles.applyBtn}></Button>
            <div>
              {permitList && permitList.length > 0 && !isTodayMode ? (
                <img
                  className={styles.downloadIcon}
                  onClick={() => onClick('loadCSV')}
                  src={downloadIcon}
                  alt="icon"
                />
              ) : null}
            </div>
          </div>
        </div>
        <div
          className={[
            'ag-theme-balham vehicleMovementTable',
            styles.tableWrapper,
            totalCount > 10
              ? styles.tableWrapperNormal
              : styles.tableWrapperAutoHeight,
          ].join(' ')}>
          <AgGridReact
            rowStyle={rowStyle}
            getRowStyle={getRowStyle}
            rowHoverHighlight={true}
            columnDefs={columnDefs}
            rowHeight={60 * heightConstant}
            headerHeight={60 * heightConstant}
            defaultColDef={{
              sortable: true,
              resizable: true,
              wrapText: true,
              cellStyle: defaultCellStyle,
            }}
            rowClass={styles.gridRowClass}
            pagination={true}
            rowModelType={'infinite'}
            paginationPageSize={perPage}
            onGridReady={onGridReady}
            cacheBlockSize={perPage}
            domLayout="autoHeight"></AgGridReact>
        </div>
        {/* <div className={styles.bottomLabel}>
          Showing {filterAgencies.length}
        </div> */}
      </div>
      <div className={styles.SannaLogo}>
        <SannaLogo />
      </div>
    </div>
  );
};
export default withRouter(Desktop);
